export const TAG_COLOR = {
  MOOD: 'blue',
  ACTIVITY: 'orange',
  GENRE: 'green',
}

export const TAG_TYPES = ['GENRE', 'ACTIVITY', 'MOOD']
